import { useParams } from 'react-router-dom';
import styles from './EditServiceShareInputButton.module.scss';
import { IServiceShareInputFiltersOptions } from '../../../../models/serviceShareInput/ServiceShareFiltersModel';
import { EditServiceShareInputForm } from './EditServiceShareInputForm';
import { useState } from 'react';

export interface IEditServiceShareInputProps {
	id: number;
	dropdownsOptions: IServiceShareInputFiltersOptions;
	triggerRefetch: () => void;
}

export const EditServiceShareInput = ({
	id,
	dropdownsOptions,
	triggerRefetch
}: IEditServiceShareInputProps) => {
	const [isInputDialogVisible, setIsInputDialogVisible] =
		useState<boolean>(false);

	return (
		<>
			<i
				className={`${styles.editIcon} pi pi-pencil`}
				onClick={() => setIsInputDialogVisible(true)}
				style={{ cursor: 'pointer' }}
			/>

			{isInputDialogVisible && (
				<EditServiceShareInputForm
					id={id}
					dropdownsOptions={dropdownsOptions}
					triggerRefetch={triggerRefetch}
					closeForm={() => {
						setIsInputDialogVisible(false);
					}}
				/>
			)}
		</>
	);
};
